import { Routes, Route } from "react-router-dom";
import { DASHBOARD, PRODUCTION_COMPONENT } from "../constants/routes";
import DashboardScreen from "../screens/DashboardScreen";

export default function UserRouter() {
  return (
    <Routes>
      <Route path={DASHBOARD} element={<DashboardScreen />} />
    </Routes>
  );
}
